import { NgModule } from '@angular/core';
import { SkyconsComponent } from './ngx-skycons.component';

@NgModule({
  declarations: [SkyconsComponent],
  imports: [
  ],
  exports: [SkyconsComponent]
})
export class SkyconsModule { }
